var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgNotesLogo = function SvgNotesLogo(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.882 47.6337L62.1133 45.8649L68.0595 39.9187C71.2445 36.7349 72.9983 32.5024 72.9983 27.9999V24.9137H75.4983V27.9999C75.4983 33.1712 73.4845 38.0312 69.8295 41.6874L63.882 47.6337Z",
    fill: "#A8B0BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 8H10.5C9.11875 8 8 9.11875 8 10.5V70.5H0.5V8C0.5 3.8575 3.8575 0.5 8 0.5C12.1425 0.5 15.5 3.8575 15.5 8Z",
    fill: "#DAD7D3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.5V10.5C8 9.11875 9.11875 8 10.5 8H15.5C15.5 12.1425 12.1425 15.5 8 15.5Z",
    fill: "#758190"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58 15.5C62.1425 15.5 65.5 12.1425 65.5 8C65.5 3.8575 62.1425 0.5 58 0.5H8C12.1425 0.5 15.5 3.8575 15.5 8C15.5 12.1425 12.1425 15.5 8 15.5H58Z",
    fill: "#B6BCC4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58 44.25V75.5H8V15.5H58V31.75",
    fill: "#E9E9E9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7422 43.0007L64.2396 25.5034L70.4885 31.7524L52.9912 49.2497L46.7422 43.0007Z",
    fill: "#C7E2FC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.25 25.5L67.955 21.795C68.7838 20.9662 69.9075 20.5 71.08 20.5C73.5213 20.5 75.5 22.4787 75.5 24.92C75.5 26.0925 75.035 27.2162 74.205 28.045L70.5 31.75",
    fill: "#3677AE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.75 43L36.75 53L43 59.25L53 49.25",
    fill: "#A8B0BC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.75 53L33 60.5L35.5 63L43 59.25",
    fill: "#3677AE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6055 64.6119L33.3558 60.8616L35.1236 62.6294L31.3732 66.3797L29.6055 64.6119Z",
    fill: "#CBC3B6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9805 45.2407L66.4778 27.7434L68.2453 29.5109L50.748 47.0082L48.9805 45.2407Z",
    fill: "#243242"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 21.75H51.75V24.25H14.25V21.75Z",
    fill: "#A8B0BC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 26.75H51.75V29.25H14.25V26.75Z",
    fill: "#A8B0BC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 31.75H51.75V34.25H14.25V31.75Z",
    fill: "#A8B0BC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 36.75H49.25V39.25H14.25V36.75Z",
    fill: "#A8B0BC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 41.75H44.25V44.25H14.25V41.75Z",
    fill: "#A8B0BC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 61.75H28V64.25H14.25V61.75Z",
    fill: "#A8B0BC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 66.75H51.75V69.25H14.25V66.75Z",
    fill: "#A8B0BC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0075 28.2575C70.4738 28.25 73.53 26.5 75.3513 23.8375C74.8663 21.9225 73.1463 20.5 71.08 20.5C69.9075 20.5 68.7838 20.965 67.955 21.795L64.25 25.5L67.0075 28.2575Z",
    fill: "#4A8DC6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M36.75 53L33 60.5L33.325 60.825C36.22 60.3025 38.865 59.0825 41.0925 57.3425L36.75 53Z",
    fill: "#4A8DC6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M46.75 43L36.75 53L41.0925 57.3425C45.0537 54.2462 47.66 49.5175 47.9137 44.1637L46.75 43Z",
    fill: "#C1C8D1"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgNotesLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/notes-logo.67098372.svg";